// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort{text-align:right}.sort svg{margin:0 5px 5px 5px;padding:0 3px 0 3px}.sort svg.active .st0,.sort svg:hover .st0{fill:#002f6c!important}.sort span{font-size:.7rem}@media(max-width:767.98px){.sort{text-align:center!important}}", ""]);
// Exports
module.exports = exports;
